var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"back"}),_c('div',{staticClass:"goodss"},[_c('h6',{staticClass:"titles"},[_vm._v(" 师资汇聚，实战经验倾囊相授 "),_c('div',{staticClass:"eng"},[_vm._v("Team")])]),_c('div',[_c('img',{staticClass:"teacher",attrs:{"src":require("../../img/newteacher.jpg"),"alt":""}})])])])
}]

export { render, staticRenderFns }